import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import { ModalArchiveDrsFileProps } from "components/ModalArchiveDrsFile/ModalArchiveDrsFile";
import { ModalUnarchiveDrsFiles } from "components/ModalUnarchiveDrsFile/ModalUnarchiveDrsFile";
import { useState } from "react";
import { getDrsFileModifyPermissionByDrsFileAndAction } from "types/DrsFileModifyPermissions";

export interface ButtonUnarchiveDrsFileProps {
  drsFile: Parameters<typeof getDrsFileModifyPermissionByDrsFileAndAction>[0] &
    ModalArchiveDrsFileProps["drsFiles"][number];
}

export const ButtonUnarchiveDrsFile = ({
  drsFile,
}: ButtonUnarchiveDrsFileProps) => {
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  return (
    <>
      <ButtonIconPermissioned
        aria-label="Unarchive file"
        defaultTooltip={"Unarchive file"}
        color="primary"
        iconType="tear"
        disabled={
          !getDrsFileModifyPermissionByDrsFileAndAction(drsFile, "UNARCHIVE")
            .isPermitted
        }
        onClick={() => {
          setShowConfirmModal(true);
        }}
        requiredPermission="edit"
      />
      {showConfirmModal && (
        <ModalUnarchiveDrsFiles
          drsFiles={[drsFile]}
          onClose={() => setShowConfirmModal(false)}
        />
      )}
    </>
  );
};
